import { Routes } from '@angular/router';
import { RedirectComponent } from '../pages/redirect/redirect.component';
import { SportGuard } from '../services/redirect/sport-guard';

const footballHomeImport = import(
  '../pages/sports/football/home/home.component'
);

export const ROUTE_FOOTBALL = 'futbol';
export const ROUTE_FOOTBALL_EN = 'en/football';
export const ROUTE_SPORTS = ':sport/todos-los-partidos';
export const ROUTE_SPORTS_EN = 'en/:sport/all-matches';
export const ROUTE_SPORTS_DATE = ':sport/todos-los-partidos/:date';
export const ROUTE_SPORTS_DATE_EN = 'en/:sport/all-matches/:date';

export const homeRoutes: Routes = [
  {
    path: '',
    component: RedirectComponent,
    pathMatch: 'full',
  },

  {
    path: ROUTE_FOOTBALL,
    loadComponent: () => footballHomeImport,
  },
  {
    path: ROUTE_FOOTBALL_EN,
    loadComponent: () => footballHomeImport,
  },
  {
    path: ROUTE_SPORTS,
    loadComponent: () => import('../pages/dashboard/dashboard.component'),
    canActivate: [SportGuard],
  },
  {
    path: ROUTE_SPORTS_EN,
    loadComponent: () => import('../pages/dashboard/dashboard.component'),
    canActivate: [SportGuard],
  },
  {
    path: ROUTE_SPORTS_DATE,
    loadComponent: () => import('../pages/dashboard/dashboard.component'),
    canActivate: [SportGuard],
  },
  {
    path: ROUTE_SPORTS_DATE_EN,
    loadComponent: () => import('../pages/dashboard/dashboard.component'),
    canActivate: [SportGuard],
  },
];
